"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _sidePaneActions = require("../../../redux/actions/sidePaneActions");
var _SidePaneComponent = _interopRequireDefault(require("./SidePaneComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var _state$sidePane = state.sidePane,
    isOpen = _state$sidePane.isOpen,
    name = _state$sidePane.name,
    data = _state$sidePane.data;
  return {
    isOpen: isOpen,
    name: name,
    data: data
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    close: function close(name) {
      return dispatch((0, _sidePaneActions.closeSidePane)(name));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SidePaneComponent["default"]);